module.exports = __webpack_public_path__ + "io-top.svg?9921631bde9a471bfb250feb7935d30e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/io-top.svg
// module id = 76
// module chunks = 0